import React, { useState, useEffect } from 'react'
import Overlay from 'Lib/Overlay'
import { Gpay, Phonepe, Bhim, Paytm, BinSavedCard } from 'SVGPath/expressway'
import { isInDomain } from 'AccountsUtils'
import { CrossModal } from '../../../../assets/svgs/expressway'
import { apiGetHelper, apiPostHelper, readCookie } from '../../../../utils'
import { GET_SAVED_PAYMENT_MODES, DELETE_SAVED_PAYMENT_MODES } from '../../../../constants/api_endpoints'
import SavedCardDetails from '../SavedCardDetails'
import '../../../../containers/Expressway/expressway.scss'

const SavedCard = props => {
  const { setShowError, setErrorMessage } = props
  const [cards, setCards] = useState([])
  const [vpas, setVpas] = useState([])
  const [showDeleteCardModal, setShowDeleteCardModal] = useState(false)
  const [showDeleteUpiModal, setShowDeleteUpiModal] = useState(false)
  const [selectedCard, setSelectedCard] = useState({ id: '', number: '', sCardType: '' })
  const [selectedUpi, setSelectedUpi] = useState({ id: '', vpa: '', sUpiType: '' })

  const CARD = 'CARD'
  const UPI = 'UPI'

  useEffect(() => {
    getSavedPaymentModes()
  }, [])

  const getSavedPmodeList = () => {
    const userIdCookie = readCookie('userid')
    const userId = decodeURIComponent(userIdCookie).split('|')[4]
    const response = apiGetHelper(
      `${GET_SAVED_PAYMENT_MODES}${userId}`,
      true,
      {},
      {}
    )
    return response
  }

  async function getSavedPaymentModes() {
    try {
      const res = await getSavedPmodeList()
      if (res.status === 200 && res.data) {
        if (res.data.stored_cards) {
          setCards(res.data.stored_cards)
        }
        if (res.data.stored_vpa) {
          setVpas(res.data.stored_vpa)
        }
      }
    } catch (error) {
      // console.log(error)
    }
  }

  const showModal = (type, sId, sNumber, sType) => {
    if (type === CARD) {
      setSelectedCard({ id: sId, number: sNumber, sCardType: sType })
      setShowDeleteCardModal(true)
    } else if (type === UPI) {
      setSelectedUpi({ id: sId, vpa: sNumber, sUpiType: 'SAVED_VPA' })
      setShowDeleteUpiModal(true)
    }
  }

  const hideModal = type => {
    if (type === CARD) {
      setSelectedCard({ id: '', number: '', sCardType: '' })
    } else if (type === UPI) {
      setSelectedUpi({ id: '', vpa: '' })
    }
    setShowDeleteCardModal(false)
    setShowDeleteUpiModal(false)
  }

  const deleteSelectedPmode = async (type, sId, sPayment) => {
    try {
      const response = await apiPostHelper(
        `${DELETE_SAVED_PAYMENT_MODES}${sId}?savedPayment=${sPayment}`,
        {},
        false,
        {},
        {}
      )
      if (response.status === 200 && Array.isArray(response.data)) {
        if (type === CARD) {
          setCards(response.data)
        } else if (type === UPI) {
          setVpas(response.data)
        }
      } else if (response &&
        response.error &&
        response.error.response &&
        response.error.response.status === 500) {
        if (type === CARD) {
          setErrorMessage('Unable to delete saved card! Please try again!')
          setShowError(true)
        } else if (type === UPI) {
          setErrorMessage('Unable to delete saved UPI! Please try again!')
          setShowError(true)
        }
      }
      hideModal()
    } catch (error) {
      // console.log(error)
    }
  }

  const getUpiImage = (pspAppName = '') => {
    if (pspAppName.toLowerCase() === 'phonepe') {
      return <Phonepe />
    } if (pspAppName.toLowerCase() === 'googlepay') {
      return <Gpay />
    } if (pspAppName.toLowerCase() === 'paytm') {
      return <Paytm />
    }
    return <Bhim />
  }

  const getCardSection = () => {
    if (Array.isArray(cards) && cards.length > 0) {
      return (
        <>
          {cards.map(card => (
            <>
              <div className="flex flex-between" id={card.id}>
                <SavedCardDetails
                  cardNo={card.number}
                  type={card.type}
                  bank={card.bank}
                  tokenized={card.tokenized_card}
                  savedCardType={card.saved_card_type}
                  creditDebit={card.credit_debit}
                />
                <div
                  className="flex flex-column flex-center mr-1 cursor-pointer"
                  onClick={() => showModal(CARD, card.id, card.number, card.saved_card_type)}
                >
                  <BinSavedCard />
                </div>
              </div>
              <hr className="dotted-line mt-3" />
            </>
          ))}
          {
            showDeleteCardModal && (
              <Overlay>
                <div className="cardModal ">
                  <div className="flex flex-between">
                    <span className="cardModalDltTxt">Delete card</span>
                    <span className="cardModalDltTxt cursor-pointer" onClick={() => hideModal(CARD)}>
                      <CrossModal />
                    </span>
                  </div>
                  <div className="cardModalSeparator" />
                  <div className="cardModalText">
                    Are you sure you want to delete <span className="fw-500">{selectedCard.number}</span> card?
                  </div>
                  <button type="submit" className="cardModalBtn cursor-pointer" onClick={() => hideModal(CARD)}>No</button>
                  <button type="submit" className="cardModalBtn cursor-pointer ml-4 cardModalRed" onClick={() => deleteSelectedPmode(CARD, selectedCard.id, selectedCard.sCardType)}>Yes</button>
                </div>
              </Overlay>
            )
          }
        </>
      )
    }
    return <div className="flex flex-center noSavedCardsText"> No saved cards </div>
  }

  const getUpiSection = () => {
    if (Array.isArray(vpas) && vpas.length > 0) {
      return (
        <>
          {vpas.map(upi => (
            <>
              <div className="flex flex-between" id={upi.id} style={{ minHeight: '28px' }}>
                <div className="grey-5 fw-500 fs-20 ml-1 mt-1 flex flex-left">
                  <div className="mr-1" style={{ minWidth: '20px' }}>
                    {getUpiImage(upi.pspAppName)}
                  </div>
                  <div style={{ marginLeft: '4px' }}>
                    {upi.vpa}
                  </div>
                </div>
                <div
                  className="flex flex-column flex-center mr-1 cursor-pointer"
                  onClick={() => showModal(UPI, upi.vpaID, upi.vpa)}
                >
                  <BinSavedCard />
                </div>
              </div>
              <hr className="dotted-line mt-3" />
            </>
          ))}
          {
            showDeleteUpiModal && (
              <Overlay>
                <div className="cardModal ">
                  <div className="flex flex-between">
                    <span className="cardModalDltTxt">Delete UPI</span>
                    <span className="cardModalDltTxt cursor-pointer" onClick={() => hideModal(UPI)}>
                      <CrossModal />
                    </span>
                  </div>
                  <div className="cardModalSeparator" />
                  <div className="cardModalText">
                    Are you sure you want to delete <span className="fw-500">{selectedUpi.vpa}</span>?
                  </div>
                  <button type="submit" className="cardModalBtn cursor-pointer" onClick={() => hideModal(UPI)}>No</button>
                  <button type="submit" className="cardModalBtn cursor-pointer ml-4 cardModalRed" onClick={() => deleteSelectedPmode(UPI, selectedUpi.id, selectedUpi.sUpiType)}>Yes</button>
                </div>
              </Overlay>
            )
          }
        </>
      )
    }
    return <div className="flex flex-center noSavedCardsText"> No saved UPIs </div>
  }

  return (
    <div>
      <h2 className="mb-5 grey-5 fw-400 fs-20">Your saved cards</h2>
      {getCardSection()}
      <If condition={isInDomain()}>
        <h2 className="mt-4 mb-5 grey-5 fw-400 fs-20">Your saved UPI</h2>
        {getUpiSection()}
      </If>
    </div>
  )
}

export default SavedCard
